<div>
	<mat-toolbar>
		<button *ngIf="closeButton" [disableRipple]="true" matDialogClose class="close" mat-icon-button>
			<mat-icon>cancel</mat-icon>
		</button>
	</mat-toolbar>
	<mat-dialog-content style="max-width: 300px; min-width: 24 0px; width: auto; height: auto; padding: 0px">
		<div class="image-section" color="primary">
			<div class="action-content">
				<div class="action-image" *ngIf="data?.actionImage">
					<img [src]="data?.actionImage" />
				</div>
				<div class="action-title" *ngIf="data?.actionTitle">
					<h2>{{ data?.actionTitle }}</h2>
				</div>
				<div class="action-message" *ngIf="data?.actionMessage">
					<h5>{{ data?.actionMessage }}</h5>
				</div>
			</div>
		</div>
	</mat-dialog-content>
	<mat-dialog-actions align="center">
		<button [disableRipple]="true" mat-flat-button [mat-dialog-close]="true" cdkFocusInitial color="primary">
			{{ data.actionText }}
		</button>
		<button *ngIf="denyButton" [disableRipple]="true" mat-flat-button [mat-dialog-close]="false" cdkFocusInitial color="warn">
			{{ data.denyText }}
		</button>
	</mat-dialog-actions>
</div>
